// removed by extract-text-webpack-plugin
module.exports = {"page":"_30X81lOSfsUbC-rRfIw0rf","landscape":"_1W0V_wwJ6fRI6mLwpq5Q8C","rotated":"_1TvaciewE0yjxjR84NOlTU","portrait":"_1ezOPiIm8crv87dfnb2s7T","hasTool":"_1idCcv_gI0PJ5p_R0hBH8o","clickAway":"_2BOrtSVFW-tMiJ1j00Gujq","textComment":"_3FmGtbfAgluvA8NBV-yJj8","saved":"cii3Tslz5GhMyMEAwJzXe"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Paper/Page.css
// module id = 722
// module chunks = 3